import type { LoginRequest } from "#/types/auth";
import type { User } from "#/types/user";
import { createContext } from "react";

export interface AuthContextType {
  isLoggedIn: boolean;
  isBootstrapped: boolean;
  user?: User | null;
  login: (data: LoginRequest) => Promise<void>;
  processLogin: (user: User) => void;
  logout: () => Promise<void>;
  canDelete: () => boolean;
  canWrite: () => boolean;
  canRead: () => boolean;
}

export const AuthContext = createContext<AuthContextType | null>(null);
